export class DetalhesTrackingRequest {
  cnpjCli: string;
  idBooking: number;
  numBooking: string;
  idUsuario: number;
  numContainer: string;
  idAgendColeta: number;
}
